import { Search } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SearchModal from '../../common/modals/SearchModal/SearchModal';
import UserPopover from '../../common/popover/userPopover/UserPopover';
import Notifications from '../../notifications/Notifications';
import SubscriptionAlert from '../mainLayout/SubscriptionAlert';
import { menuAppBarStyles as styles } from './MenuAppBarStyles';
import MenuLinks from './MenuLinks';

interface MenuAppBarProps {
  setSidebarOpen: (open: boolean) => void;
}

const MenuAppBar: React.FC<MenuAppBarProps> = ({ setSidebarOpen }) => {
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <AppBar position="relative" sx={styles.appBar}>
      <Toolbar disableGutters sx={styles.toolbar}>
        {/* Mobile hamburger */}
        <IconButton size="large" edge="start" color="inherit" sx={styles.hamburger} onClick={() => setSidebarOpen(true)}>
          <MenuIcon />
        </IconButton>

        {/* Logo */}
        <Box component={Link} to="/" sx={styles.logoBox}>
          <Box component="img" src="/svg/schedulink-logo.svg" alt="logo" sx={styles.logoImg} />
        </Box>

        {/* Menu tabs */}
        <MenuLinks />

        {/* User controls */}
        <Box sx={styles.userControls}>
          <IconButton color="secondary" onClick={() => setSearchOpen(true)}>
            <Search />
          </IconButton>
          <Notifications />
          <UserPopover />
        </Box>
      </Toolbar>
      <SubscriptionAlert />
      <SearchModal open={searchOpen} onClose={() => setSearchOpen(false)} />
    </AppBar>
  );
};

export default MenuAppBar;
